<div id="content" class="allcp-form" ng-controller="CustomerController" ng-init="init()">
<div ng-include="'modules/company/menus/customer_menu.html'"></div>

<div class="navbar fixed-panel-footer" ng-if="deleted.length">
	<div class="nav navbar-nav navbar-left">
		<a href="#" ng-click="selectAll(true)" class="btn mr-2 btn-outline">Select All</a>
		<a href="#" ng-click="selectAll(false)" class="btn btn-outline">Unselect</a>
	</div>
	
	<div class="nav navbar-nav navbar-center">
	</div>

	<div class="nav navbar-nav navbar-right">
		<a href="#"
			ng-click="delete('set')" 
			ng-disabled="deleted.length == 0" 
			ng-if="deleted.length > 0"
			class="btn btn-danger btn-rounded mr-3">Delete</a>
	</div>
</div>

<div class="panel-body">
	<div class="table-responsive allcp-form" ng-if="data.customers.data.length > 0">
		
		<table class="table table-hover tc-checkbox-1 fs13 fixed-head">
			<thead>
			<tr class="bg-light ">
				<th class="text-center w75">
					<!-- <label class="option block mn ml4" style="display:block">
						<input type="checkbox" 
							name="deleted[]" ng-model="master" ng-click="toggleStatus($event)"  id="checkboxAll" >
						<span class="checkbox mn"></span>
					</label> -->
				</th>
				<th>
					Customer Name
					<a ng-click="sort('customer_name','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
						<i class="fa fa-sort-alpha-desc"></i>
					</a>
					<a ng-click="sort('customer_name','asc')" ng-if="filterData.sort == 'desc'">
						<i class="fa fa-sort-alpha-asc"></i>
					</a>
				</th>
				<th>
					Phone
					<a ng-click="sort('phone_number','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
						<i class="fa fa-sort-alpha-desc"></i>
					</a>
					<a ng-click="sort('phone_number','asc')" ng-if="filterData.sort == 'desc'">
						<i class="fa fa-sort-alpha-asc"></i>
					</a>
				</th>
				<th>
					Address
					<a ng-click="sort('address','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
						<i class="fa fa-sort-alpha-desc"></i>
					</a>
					<a ng-click="sort('address','asc')" ng-if="filterData.sort == 'desc'">
						<i class="fa fa-sort-alpha-asc"></i>
					</a>
				</th>
				<th>
					City
					<a ng-click="sort('city','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
						<i class="fa fa-sort-alpha-desc"></i>
					</a>
					<a ng-click="sort('city','asc')" ng-if="filterData.sort == 'desc'">
						<i class="fa fa-sort-alpha-asc"></i>
					</a>
				</th>
				<th>
					State
					<a ng-click="sort('state','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
						<i class="fa fa-sort-alpha-desc"></i>
					</a>
					<a ng-click="sort('state','asc')" ng-if="filterData.sort == 'desc'">
						<i class="fa fa-sort-alpha-asc"></i>
					</a>
				</th>
				<th>
					Zipcode
					<a ng-click="sort('zipcode','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
						<i class="fa fa-sort-alpha-desc"></i>
					</a>
					<a ng-click="sort('zipcode','asc')" ng-if="filterData.sort == 'desc'">
						<i class="fa fa-sort-alpha-asc"></i>
					</a>
				</th>
				<th>Total Order</th>
				<th ng-repeat="item in data.fields">{{ item.name }}</th>
			</tr>
			</thead>
			<tbody>
			<tr class="text-left" 
				dir-paginate="item in data.customers.data | filter: search | orderBy:sortType:sortReverse | itemsPerPage: 30" 
				total-items="data.customers.total" 
				current-page="data.customers.current_page">
				<td class="text-center">
					<label class="option block mn">
						<input type="checkbox" 
							name="deleted[]"
							ng-checked="deleted.indexOf(item.id) > -1 || master"
							ng-click="toggleSelection(item.id)">
						<span class="checkbox mn"></span>
					</label>
				</td>

				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.customer_name }}</td>
				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.phone_number }}</td>
				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.address }}</td>
				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.city }}</td>
				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.state }}</td>
				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.zipcode }}</td>
				<td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.total }}</td>
				<td 
					ng-repeat="fields in data.fields"
					class="clickable-row" 
					ng-click="getCustomerDetails(item.id)">
					<span ng-repeat="field in item.fields_values">
						{{ fields.id == field.customer_field_id ? field.value : '' }}
					</span>
				</td>
			</tr>
			</tbody>
		</table>
		<small class="pull-right pr10 total-record">Total : {{ data.customers.total }}</small>
		<dir-pagination-controls 
			boundary-links="true" 
			on-page-change="getPage(newPageNumber)" 
			template-url="dirPagination.tpl.html"
			class="pagination-lg pagination pull-right pr10">
		</dir-pagination-controls>

	</div>
	<div class="table-responsive" ng-if="data.customers.data.length == 0">
		<div class="alert alert-default pastel">
			<i class="fa fa-info pr10"></i>
			<strong>
				Partner Not Found!
			</strong>
		</div>
	</div>
</div>
<div ng-include="'modules/company/customers/new.html'"></div>
<div ng-include="'modules/company/customers/edit.html'"></div>

<div id="customer_map" style="width:100% !important; height:500px !important" ng-show="type == 'map'"></div>
<div ng-include="'modules/company/settings/partials/delete.html'"></div>

<!-- Modal -->
<div class="modal right fade" id="importCustomerList" tabindex="-1" role="dialog" aria-labelledby="importCustomerListLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="importCustomerListLabel">Excelden Müşteri Listesi Aktar</h4>
      </div>
	  <form ng-submit="importCustomerList(excel)">
      <div class="modal-body">
		<div class="loading" ng-if="upload">
			<div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
		</div>
		<div class="row mb20">
			<div class="col-md-12">

				<div class="col-md-6">
					<i class="fa fa-file-excel-o" style="font-size:180px !important" aria-hidden="true"></i>
				</div>

				<div class="col-md-6">
					<h3> 
						<span style="border-radius: 50% !important;background: #7F828F;color: #fff;width: 30px;height: 30px;padding: 1px;display: inline-block;text-align: center;margin-right: 10px;font-size: 24px;">1</span>
						Örnek Dosya
					</h3>
					<a href="#" ng-click="donwloadSampleExcel()" class="btn btn-primary">Örnek Excel Dosyasını İndİr</a>
					<p>Bu dosyayı indirerek, verilerinizi bu dosya formatına getiriniz.</p>
				</div>

			</div>
			<div class="col-md-12"><hr ></div>			
			<div class="col-md-12">
				<h3> 
					<span style="border-radius: 50% !important;background: #7F828F;color: #fff;width: 30px;height: 30px;padding: 1px;display: inline-block;text-align: center;margin-right: 10px;font-size: 24px;">2</span>
					Dosya Seç
				</h3>
				<div class="allcp-form theme-primary">
					<p>Örnek dosya ile hazırladığınız, excel müşteri listesini seçiniz.</p>
					<input type="file" fileread="uploadme">
				</div>
			</div>
		</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
        <button type="submit" class="btn btn-primary">Aktarmaya Başla</button>
      </div>
	  </form>
    </div>
  </div>
</div>

</div>